


let productsDetailsSliderOptions = {
    arrows: true,
    infinite: true,
    dots: true,
    mobileFirst: true,
    prevArrow: "<button type='button' class='new-slick-prev' title='prev'><i class='fas fa-chevron-left'></i></button>",
    nextArrow: "<button type='button' class='new-slick-next' title='next'><i class='fas fa-chevron-right'></i></button>",
    responsive: [
        {
            breakpoint: 1024,
            settings: "unslick",
            unslick: true,
        }
    ]
};


$(document).ready(function () {
    
    //inizializzati tooltip info

    $('[data-tooltip="tooltip"]').tooltip();

    $(".trustpilot-overlay").on("click", function (e) {
        $("#reviewTabTP").click()
        const review = $('#reviewTabTP');
        if (review.length) {
            $('html, body').animate({
                scrollTop: review.offset().top - 150
            }, 2000);
        }
    })

    // carousel u may also like
    let productsSliderOptions = {
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false, 
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: true,
                    arrows: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                }
            }
        ]
    };

    let thumbanilsOptions = {
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-imageCarousel',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1367,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    }

    if(!$('.slider-imageCarousel').hasClass("slick-initialized")){
        $('.slider-imageCarousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-thumbnails'
        });
    }

    if(!$('.slider-thumbnails').hasClass("slick-initialized")){
        $('.slider-thumbnails').slick(thumbanilsOptions);
    }

    $(".js-product-list-slider").each(function() {
        $(this).slick(productsSliderOptions);
    });

    // Product details images slider page
    $(".js-products-details__slider").each(function() {

        var $slider = $(this);
        if ($(window).width() < 1024 && !$(this).hasClass("slick-initialized")) {
            $slider.slick(productsDetailsSliderOptions);
        }

        $slider.find(".product-details__image > img").click(function () {
            var index = $(this).data('slide-to');
            $('#gallery-modal').modal('show');
            $('#gallery-carousel').carousel(index);
            $('#gallery-carousel-modal').carousel(index);
        });
    });

    $("#gallery-carousel").find(".carousel-item > img").click(function () {
        var index = $(this).data('slide-to');
        $('#gallery-modal').modal('show');
        $('#gallery-carousel').carousel(index);
        $('#gallery-carousel-modal').carousel(index);
    });

    $(".js-products-details__slider").each(function() {
        if ($(window).width() < 1024) {
        let $slider = $(this);
        if ($slider.hasClass("initialized")) return;

        const $sliderDotsContainer = $slider.find(".slick-dots");
        const $sliderDots = $sliderDotsContainer.find("li");
        const counterDots = $sliderDots.length;

        if(counterDots > 1) {
            let widthDots = 100 / counterDots + '%'; 
            $sliderDots.css('width', widthDots);
            $slider.addClass("initialized");
        } else {
            $sliderDotsContainer.css('height', 'auto');
            $sliderDots.css('display', 'none');
            $slider.addClass("initialized");
        }
        $slider.addClass("initialized");
    }
    });

    // icone del carousel
    // if ($(window).scrollTop() > $(".main__gallery").outerHeight() - 150){
    //     $('.product-details__slider__menu').removeClass('fixed');
    //  }
    // $(window).scroll(function(){
    //     if ($(window).scrollTop() > $(".main__gallery").outerHeight() - 150){
    //        $('.product-details__slider__menu').removeClass('fixed');
    //     } else {
    //        $('.product-details__slider__menu').addClass('fixed');
    //     }
    // });

    // read more della descrizione
    let size_li = $(".main__description ul li").size();
    let x=3;
    
    $('.main__description ul li:lt('+x+')').show();
    $('.main__description ul  li').not(':lt('+x+')').hide();
    if(x >= size_li){
        $('.read-more').hide();
        $('.read-less').hide();
    } else {
        $('.read-more').show();
        $('.read-less').hide(); 
    }
    $('.read-more').click(function () {
        x= (x+8 <= size_li) ? x+8 : size_li;
        $('.main__description ul  li:lt('+x+')').show();
        $('.read-less').show();
        if(x == size_li){
            $('.read-more').hide();
        }
    });
    $('.read-less').click(function () {
        x=(x-10<0) ? 3 : x-8;
        $('.main__description ul  li').not(':lt('+x+')').hide();
        $('.read-more').show();
        $('.read-less').show();
        if(x == 3){
            $('.read-less').hide();
        }
    }); 
    // if($('.main__description ul').height() >= 124) {
       
    //     $('.read-more').show();
    //     $('.read-less').show();
    // } else {
    //     $('.read-more').hide();
    //     $('.read-less').hide();
    // }
    // $(window).resize(function () {
    //     if($('.main__description ul').height() >= 124) {
    //         $('.read-more').show();
    //         $('.read-less').show();
    //     } else {
    //         $('.read-more').hide();
    //         $('.read-less').hide();
    //     }
    // });
    // $('.read-more').on('click', function(e){
    //     $('.main__description').addClass('close-details')
    // })
    // $('.read-less').on('click', function(e){
    //     $('.main__description').removeClass('close-details')
    // })


    //POPOVER benefits
    $("[data-toggle=popover]").popover({
        trigger: 'manual',
        html : true,
        sanitize:false,
        content: function () {
            var clone = $($(this).data('popover-content')).clone(true).removeClass('hide');
            return clone;
        }
    })

    $("[data-toggle=popover]").on('click', function (e) {
        var $this = $(this);

        $("[data-toggle=popover]").not(this).popover('hide');

        if ($this.attr('aria-describedby')) {
            $this.popover('hide');
        } else {
            $this.popover('show');
        }

        e.stopPropagation();
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.popover').length && !$(e.target).closest('[data-toggle=popover]').length) {
            $("[data-toggle=popover]").popover('hide');
        }
    });

    // Ancore alle tab
    $('.main__info__menu a').each(function(e){
        $(this).on('click', function(e){
            e.preventDefault();
            var hash = $(this).attr('href');
            var tabHash = $(this).attr('data-tab-href');

            $(tabHash).trigger('click');
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 215
            }, 2000);
            $(hash).find('h2').trigger('click');
        })
    })

    //creazione buy fixed bar
    if($('.buy-fixed-bar .prices').length == 0 && $('.btn-backInStock').length == 0) {
        $('.product-details__infos__price .prices').clone().appendTo('.buy-fixed-bar');
    }
    if($('.buy-fixed-bar .product-comparison').length == 0 && $('.btn-backInStock').length == 0) {
        $('.product-comparison').clone().appendTo('.buy-fixed-bar');
    }
   
    if($('.buy-fixed-bar .product-link__buy').length == 0) {
        $('.product-details__infos__btn .product-link__buy').clone().appendTo('.buy-fixed-bar');
    }
   
    // if($('.buy-fixed-bar .backInStock-wrap').length == 0) {
    //     $('.backInStock-wrap').clone().appendTo('.buy-fixed-bar');
    // }

    if($('.btn-backInStock').length != 0 && $('.buy-fixed-bar .product-cta__compare__wish .product-link__wishlist').length == 0 ) {
        $('.product-cta__compare__wish .product-link__wishlist').clone().appendTo('.buy-fixed-bar');
    } 

    if($('.btn-backInStock').length != 0 && $('.buy-fixed-bar .btn-backInStock').length == 0 ) {
        $('.btn-backInStock').clone().appendTo('.buy-fixed-bar');
    }

    // Accordion subdetail in tab caratteristiche

    if ($('.product-subdetail').length) {
        $('.product-subdetail').each(function(){
            $(this).addClass('isAccordion');
            $(this).on('click' , function(){
                $(this).toggleClass('open');
            })
        })
    }

    if ($('.product-detail').length) {
        $('.product-detail').each(function(){
            $(this).addClass('isAccordion');
            $(this).find('.product-detail__title').on('click' , function(){
                $(this).parent().toggleClass('open');
            })
        })
    }
});


// Reslick only if it's not slick()
$(window).on('resize', function() {
    if ($(window).width() < 1024) {
        $(".js-products-details__slider").each(function() {
            if (!$(this).hasClass("slick-initialized")) {
                $(this).slick(productsDetailsSliderOptions);
            }; 
        });
    } 
    if ( $(window).width() < 780 ){
        $('[data-tooltip="tooltip"]').tooltip('disable');
    }
    if ( $(window).width() > 780 ){
        $('[data-tooltip="tooltip"]').tooltip('enable');
    }
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('scroll', function() {
    if (isTouch()) {
        const cookiefirstRoot = $('.cookiefirst-root')
        const footerBackToTop = $('.footer_backToTop')
        const accessiWayWidget = $('access-widget-ui[data-acsb=""]')
        if ($('.product-details__infos__price').isInViewport()) {
            $('.buy-fixed-bar').addClass('hide');
            cookiefirstRoot.length ? cookiefirstRoot.removeClass('moveTop') : '';
            footerBackToTop.length ? footerBackToTop.removeClass('moveTop') : '';
            accessiWayWidget.length ? accessiWayWidget.removeClass('moveTop') : '';
        } else {
            $('.buy-fixed-bar').removeClass('hide');
            cookiefirstRoot.length ? cookiefirstRoot.addClass('moveTop') : '';
            footerBackToTop.length ? footerBackToTop.addClass('moveTop') : '';
            accessiWayWidget.length ? accessiWayWidget.addClass('moveTop') : '';
        }
    }
});

function setBuyBottomOffset(offset) {
    $('.buy-fixed-bar').css('bottom', offset + 'px');
}

function handleStickyBuyWhenScrolling() {
    var scrollThreshold = $(document).height() - $('.footer').outerHeight();
    var scrollPosition = $(document).scrollTop() + $(window).height();
    var diff = scrollPosition - scrollThreshold;
    if (diff > 0) {
        setBuyBottomOffset(diff);
    } else {
        setBuyBottomOffset(0);
    }
}

function showActiveProductCategory(keyframes, options){
    const $scrollBar = $('.tab-component.js-tab-component');
    let $currentEl = $('.tab-component__button');

    if($currentEl){
        $currentEl.click(function() {
            let current = $(this);
            let offset = 0;

            while(current.prev().hasClass('tab-component__button')){
                current = current.prev(); offset += current.width();
            }

            let new_offset = offset - $scrollBar.scrollLeft();
            $scrollBar.animate({ scrollLeft: '+=' + new_offset }, 300, 'swing');
        });
    }
}
const openBackInStock = () => {
    const queryParameter = 'openBackInStock';
    const targetElement = $('.js_backInStock')
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isAlternativeProduct = urlParams.get(queryParameter)
    if(isAlternativeProduct) {
        targetElement.click();
        window.history.pushState({}, document.title, removeURLParameter(window.location.href,queryParameter));
    }
}

// function stickyColumn() {
//     if (window.innerWidth >= 1024) {
//         if ($(".main__product__info-wrap").height() > ($(".product-details__slider__wrap").height() + 250) ) {
//             $(".product-details__slider__wrap").stick_in_parent({
//                 sticky_class: "is_stuck",
//                 offset_top: 200,
//                 spacer: false,
//                 parent: ".row"
//             }).on("sticky_kit:bottom", function(e) {
//                 //console.log("has bottom!", e.target);
//                 $('.product-details__slider__menu').addClass('fixedBottom');
//
//               }).on("sticky_kit:unbottom", function(e) {
//                // console.log("has unbottom!", e.target);
//                 $('.product-details__slider__menu').removeClass('fixedBottom');
//
//               });
//         } else if ($(".main__product__info-wrap").height() < ($(".product-details__slider__wrap").height() - 250) ) {
//             $(".main__product__info-wrap").stick_in_parent({
//                 sticky_class: "is_stuck",
//                 offset_top: 200,
//                 spacer: false,
//                 parent: ".row"
//             });
//         }
//     }
// }

function zoomImage(){
    $('.zoomable-image.zoomable-image').trigger('zoom.destroy');
    $('.carousel-item.active.zoomable-image').zoom({on: 'click', magnify: 2, touch: true, 
        onZoomIn: function() {
            $('.zoom-plus').hide();
            $('.zoom-minus').show();
        },
        onZoomOut: function() {
            $('.zoom-minus').hide();
            $('.zoom-plus').show();
        }
    });
}



function initProductDetail() {
    showActiveProductCategory();
    openBackInStock();
    //window.addEventListener('scroll', handleStickyBuyWhenScrolling);
    // stickyColumn();

    $(window).on('resize',function() {
        if (window.innerWidth > 1024) {
            // stickyColumn();
            if ($(".main__product__info-wrap").height() < ($(".product-details__slider__wrap").height() - 200) ) {
            $(".main__product__info-wrap").trigger("sticky_kit:recalc");
            }
            if ($(".main__product__info-wrap").height() > ($(".product-details__slider__wrap").height() + 200) ) {
            $(".product-details__slider__wrap").trigger("sticky_kit:recalc"); 
            }
        } else {
            $(".main__product__info-wrap").trigger("sticky_kit:detach");
            $(".product-details__slider__wrap").trigger("sticky_kit:detach");
        }
    })

    $(".isAccordion img[title]").tooltip({container: '.tooltip-service'}); 

    $('#gallery-modal').on('show.bs.modal', function (event) {
            $('.zoom-minus').hide();
            $('.zoom-plus').show();
            zoomImage()

            $('#gallery-carousel-modal').on('slide.bs.carousel', function() {
                setTimeout(() => {
                    zoomImage()
                }, "1000");
            });       
    });

}

$(document).ready(initProductDetail);
